export default __webpack_public_path__ + "static/media/drainessence.ce88f8f6.png";